
// 絞り込み
function onFilterBtnClick() {
  var filterForm = document.searchFilter;
  var searchUrl = "/collections/all-items?sort_by=created-descending&filter.v.price.gte=&filter.v.price.lte=";

  // 商品タイプ
  var selectedProductTypes = document.querySelectorAll(".search-filter__input input[name='filter_types']:checked");
  if(selectedProductTypes.length > 0) {
    selectedProductTypes.forEach(function(item){
      searchUrl += "&filter.p.product_type=" + item.value;
    })
  }
  // ブランド
  var selectedBrands = document.querySelectorAll(".search-filter__input input[name='filter_vendors']:checked");
  if(selectedBrands.length > 0) {
    selectedBrands.forEach(function(item){
      searchUrl += "&filter.p.vendor=" + item.value;
    })
  }
  // カテゴリー
  var selectedCategories = document.querySelectorAll(".search-filter__input input[name='filter_categories']:checked");
  if(selectedCategories.length > 0) {
    selectedCategories.forEach(function(item){
      searchUrl += "&filter.p.m.my_fields.category=" + item.value;
    })
  }
  // カラー
  var selectedColors = document.querySelectorAll(".search-filter__input input[name='filter_colors']:checked");
  if(selectedColors.length > 0) {
    selectedCategories.forEach(function(item){
      searchUrl += "&filter.p.m.my_fields.color=" + item.value;
    })
  }
  // ソール
  var selectedSoles = document.querySelectorAll(".search-filter__input input[name='filter_soles']:checked");
  if(selectedSoles.length > 0) {
    selectedCategories.forEach(function(item){
      searchUrl += "&filter.p.m.my_fields.soletype=" + item.value;
    })
  }
  // 価格
  var priceMin = document.querySelector(".search-modal #priceMin").value;
  var priceMax = document.querySelector(".search-modal #priceMax").value;
  if(priceMin) searchUrl += "&filter.v.price.gte=" + priceMin;
  if(priceMax) searchUrl += "&filter.v.price.lte=" + priceMax;

  window.location.href = encodeURI(searchUrl);
}
var filterBtn = document.querySelector("#filterBtn");
filterBtn.addEventListener("click", onFilterBtnClick);


// リセット
function onResetBtnClick() {
  // 商品タイプ
  var selectedProductTypes = document.querySelectorAll(".search-filter__input input[name='filter_types']:checked");
  selectedProductTypes.forEach(function(item){ item.checked = false; });
  // ブランド
  var selectedBrands = document.querySelectorAll(".search-filter__input input[name='filter_vendors']:checked");
  selectedBrands.forEach(function(item){ item.checked = false; });
  // カテゴリー
  var selectedCategories = document.querySelectorAll(".search-filter__input input[name='filter_categories']:checked");
  selectedCategories.forEach(function(item){ item.checked = false; });
  // カラー
  var selectedColors = document.querySelectorAll(".search-filter__input input[name='filter_colors']:checked");
  selectedColors.forEach(function(item){ item.checked = false; });
  // ソール
  var selectedSoles = document.querySelectorAll(".search-filter__input input[name='filter_soles']:checked");
  selectedSoles.forEach(function(item){ item.checked = false; });
  // 価格
  document.querySelector(".search-modal #priceMin").value = "";
  document.querySelector(".search-modal #priceMax").value = "";
  
}
var resetBtn = document.querySelector("#resetBtn");
resetBtn.addEventListener("click", onResetBtnClick);


window.onload = function() {

  // 選択済み
var url = new URL(window.location.href);
  var params = url.searchParams;

  if(params) {
    // 商品タイプ
    var productTypes = params.getAll('filter.p.product_type');
    if(productTypes) productTypes.forEach(function(item){ document.querySelector('.search-filter__input input[value="'+item+'"]').checked = true; });
    // ブランド
    var brands = params.getAll('filter.p.vendor');
    if(brands) brands.forEach(function(item){ document.querySelector('.search-filter__input input[value="'+item+'"]').checked = true; });
    // カテゴリー
    var categories = params.getAll('filter.p.m.my_fields.category');
    if(categories) categories.forEach(function(item){ document.querySelector('.search-filter__input input[value="'+item+'"]').checked = true; });
    // カラー
    var colors = params.getAll('filter.p.m.my_fields.color');
    if(colors) colors.forEach(function(item){ document.querySelector('.search-filter__input input[value="'+item+'"]').checked = true; });
    // ソール
    var soles = params.getAll('filter.p.m.custom.soletype');
    if(soles) soles.forEach(function(item){ document.querySelector('.search-filter__input input[value="'+item+'"]').checked = true; });
    // 価格
    var priceMin = params.getAll('filter.v.price.gte');
    var priceMax = params.getAll('filter.v.price.lte');
    document.querySelector('.search-modal #priceMin').value = priceMin;
    document.querySelector('.search-modal #priceMax').value = priceMax;
  }

  // アコーディオン
  function onAccordionClick(e) {
    console.log(e.target);
    if(e.target.classList.contains('is-open')) {
      e.target.classList.remove('is-open');
    } else {
      e.target.classList.add('is-open');
    }
  }
  var accordionBtns = document.querySelectorAll('.search-filter__label');
  accordionBtns.forEach(function(item) {
    item.addEventListener('click', onAccordionClick);
  });
}
